import { FC, useState } from 'react';
import { Modal } from 'react-daisyui';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { CategoryTip } from '@/api/useCategoryTips';

interface TipButtonProps {
  tip: CategoryTip;
}

const TipButton: FC<TipButtonProps> = ({ tip }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className="bg-primary hover:bg-brand-hover text-white px-6 py-3 rounded-xl font-medium transition-colors"
      >
        {tip.title}
      </button>

      <Modal open={showModal} onClose={() => setShowModal(false)} className="max-w-6xl">
        <Modal.Header className="font-bold text-xl flex items-center justify-between">
          <span>{tip.title}</span>
          <button
            onClick={() => setShowModal(false)}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors"
            aria-label="Close modal"
          >
            <XMarkIcon className="w-6 h-6 text-gray-600" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <div
            className="tip-content"
            dangerouslySetInnerHTML={{ __html: tip.content }}
          />
        </Modal.Body>
        <Modal.Actions>
          <button
            onClick={() => setShowModal(false)}
            className="bg-accent hover:bg-dark-hover-secondary text-white px-8 py-3 rounded-xl font-medium w-full"
          >
            Close
          </button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default TipButton;
